module.exports = __webpack_public_path__ + "media/images/shared/icon_tips_black-c924f2c77b0e2f161e479e9d7cc88079.png";